import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import ContainerViewActivity from "./containerView/ContainerViewActivity";
import ContainerViewDetails from "./containerView/ContainerViewDetails";
import ContainerViewNotifications from "./containerView/ContainerViewNotifications";
import FloatingLockToggle from "./FloatingLockToggle";
import { FaLock } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import {
  getContainerFillingAlert,
  getContainersList,
  getHistoryCycleContainer,
  getHistoryFillingSpeed,
  updateContainer,
} from "../../services/container";
import Loading from "../../components/utils/Loading";
import PageHeader from "../../components/PageHeader";

const ContainerDetailsView = () => {
  const viewMode = Cookies.get("viewMode") || "client";

  const token = Cookies.get("userToken");
  const { t } = useTranslation();
  const { id } = useParams();
  const [container, setContainer] = useState(null);
  const [containers, setContainers] = useState(null);
  const [countContentCategory, setCountContentCategory] = useState(null);
  const max_session_size = process.env.REACT_APP_MAX_SESSION_SIZE;
  const [showActivity, setShowActivity] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [isAkanthasAccount, setIsAkanthasAccount] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  const updateData = (newData) => {
    const historyCurrentSize = new Blob([
      JSON.stringify(newData.historyCurrent),
    ]).size;
    if (historyCurrentSize < max_session_size) {
      const containerDetails = {
        _id: container._id,
        _time: new Date().toISOString(),
        container: newData,
        containers: containers,
      };
      sessionStorage.setItem(
        "containerDetails",
        JSON.stringify(containerDetails),
      );
    }
    setContainer(newData);
  };

  useEffect(() => {
    const email = Cookies.get("userEmail") || "";
    setIsAkanthasAccount(email.includes("@akanthas.com"));
  }, [isAkanthasAccount]);

  const fetchHistoryCycle = async () => {
    try {
      const [
        responseHistoryCurrent,
        responseSpeedFilling,
        responseFillingAlert,
      ] = await axios.all([
        getHistoryCycleContainer(
          {
            currentCycle: true,
            getLevelLastRotation: true,
          },
          id,
        ),
        getHistoryFillingSpeed(id),
        getContainerFillingAlert(id),
      ]);

      if (
        responseHistoryCurrent.status === 200 ||
        responseSpeedFilling.status === 200 ||
        responseFillingAlert.status === 200
      ) {
        const result = {
          historyCurrent: responseHistoryCurrent.data.historyCycle,
          numberOfStars: responseHistoryCurrent.data.numberOfStars,
          numberOfAnomaly: responseHistoryCurrent.data.numberOfAnomaly,
          anomalyDelivery: responseHistoryCurrent.data.anomalyDelivery,
          numberOfPackmat: responseHistoryCurrent.data.numberOfPackmat,
          totalVolumeSortingError:
            responseHistoryCurrent.data.totalVolumeSortingError,
          totalWasteVolume: responseHistoryCurrent.data.totalWasteVolume,
          meanFillingLevelByOpenedDay:
            responseSpeedFilling.data.fillingPerOpenedWeekday[0],
          meanFillingLevelByOpenedHour:
            responseSpeedFilling.data.fillingPerOpenedHour[0],
          meanFillingLevelByDay: responseSpeedFilling.data.fillingPerWeekday[0],
          levelLastRotation: responseHistoryCurrent.data.levelLastRotation[0],
          dateLastRotation:
            responseHistoryCurrent.data.historyCycle[
              responseHistoryCurrent.data.historyCycle.length - 1
            ],
          lastRotation: responseHistoryCurrent.data.lastRotation[0],
          lastPackmatEfficiency:
            responseHistoryCurrent.data.lastPackmatEfficiency[0],
        };
        return result;
      } else {
        throw new Error("One or more API calls did not return status 200.");
      }
    } catch (error) {
      console.error("Error fetching history cycle data:", error);
      throw error;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);

        let containerData = {};
        let allContainers = [];
        let contentCategoryCount = 0;

        const storedData = sessionStorage.getItem("containerDetails");
        if (storedData) {
          const { container, containers, countContentCategory } =
            JSON.parse(storedData);
          containerData = container;
          allContainers = containers;
          setCountContentCategory(countContentCategory);
        } else {
          const response = await getContainersList({
            page: null,
            limit: null,
            fieldSort: "filling_level",
            orderSort: "-1",
            typeFillingFilter: "all",
          });

          if (response.status === 200) {
            allContainers = response.data.data;

            const containerFind = allContainers.find((item) => item._id === id);

            const historyCycleData = await fetchHistoryCycle();

            containerData = {
              ...containerFind,
              ...historyCycleData,
            };

            const contentCategoryContainers = allContainers.filter(
              (item) =>
                item.contentCategoryJoin.label ===
                containerData.contentCategoryJoin.label,
            );

            contentCategoryCount = contentCategoryContainers.length;
            setCountContentCategory(contentCategoryCount);

            const containerDetails = {
              _id: containerData._id,
              _time: containerData._time,
              container: containerData,
              containers: allContainers,
              countContentCategory: contentCategoryCount,
              viewType: "monitoring",
            };
            sessionStorage.setItem(
              "containerDetails",
              JSON.stringify(containerDetails),
            );
          }
        }

        // update stats
        setContainer(containerData);

        setContainers(allContainers);
        const hasMonitoringActivityAccess =
          !!containerData.activatedActivityOption ||
          !!containerData.activatedFillingLevelOption ||
          !!containerData.activatedSortingErrorOption;
        setShowActivity(hasMonitoringActivityAccess);
        setShowDetails(
          !hasMonitoringActivityAccess && !containerData.characterization,
        );
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
    // eslint-disable-next-line
  }, [id]);

  const handleToggle = async (key) => {
    const newContainer = { ...container, [key]: !container[key] };
    updateData(newContainer);

    const params = { ...newContainer };
    delete params.historyCurrent;

    await updateContainer(params, params._id);
  };
  if (token) {
    return isLoading ? (
      <Loading color="#efefeffb" />
    ) : (
      <div className="settings-page-wrapper" style={{ minWidth: "850px" }}>
        <PageHeader
          showBackButton
          backRoute="/containers"
          backLabel={t("Back to Monitoring")}
          titleContent={
            <div className="flex items-center gap-3 flex-wrap">
              <span>
                {(container?.contentCategory &&
                  container?.contentCategory.label) ||
                  container?.wasteName ||
                  "-"}
              </span>
              <span
                className="inline-flex items-center justify-center rounded-full text-sm font-bold text-[#2563EB]"
                style={{
                  padding: "4px 12px",
                  height: "30px",
                  background: "#E6ECFD",
                  borderRadius: "1000px",
                }}
              >
                {((container?.volume > 0 && container.volume) ||
                  container.volumeToCubicMeter) +
                  " " +
                  (container.volumeUnit || "m3")}
              </span>
              <span
                className="inline-flex items-center px-3 py-1 rounded-full text-sm font-bold bg-white text-[#222222]"
                style={{ border: "1.5px solid #030303" }}
              >
                {container?.addressName || "-"}
              </span>
            </div>
          }
          titleContentMain={
            <span>
              {(container?.contentCategory &&
                container?.contentCategory.label) ||
                container?.wasteName ||
                "-"}
            </span>
          }
          titleContentBadges={
            <>
              <span
                className="inline-flex items-center justify-center rounded-full text-sm font-bold text-[#2563EB]"
                style={{
                  padding: "4px 12px",
                  height: "30px",
                  background: "#E6ECFD",
                  borderRadius: "1000px",
                }}
              >
                {((container?.volume > 0 && container.volume) ||
                  container.volumeToCubicMeter) +
                  " " +
                  (container.volumeUnit || "m3")}
              </span>
              <span
                className="inline-flex items-center px-3 py-1 rounded-full text-sm font-bold bg-white text-[#222222]"
                style={{ border: "1.5px solid #030303" }}
              >
                {container?.addressName || "-"}
              </span>
            </>
          }
          subtitle={`${container?.positioning ? container.positioning.charAt(0).toUpperCase() + container.positioning.slice(1) : ""} - ${t("Date de dépôt")} : ${
            container?.historyCurrent && container.historyCurrent.length > 0
              ? (() => {
                  const language = i18n.language || "fr-FR";
                  const dateString = new Date(
                    container.historyCurrent[
                      container.historyCurrent.length - 1
                    ]._time,
                  ).toLocaleString(language, {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  });
                  return language.startsWith("fr")
                    ? dateString.replace(":", "h")
                    : dateString;
                })()
              : "-"
          }`}
          tabs={[
            container.activatedActivityOption ||
            container.activatedFillingLevelOption ||
            container.activatedSortingErrorOption ||
            (isAkanthasAccount && viewMode === "admin")
              ? {
                  id: "activity",
                  label: (
                    <span
                      className="flex items-center gap-1"
                      style={{ minHeight: "20px", lineHeight: "20px" }}
                    >
                      {!container.activatedActivityOption &&
                        !container.activatedFillingLevelOption &&
                        !container.activatedSortingErrorOption && (
                          <FaLock style={{ fontSize: "12px" }} />
                        )}
                      {t("Activity")}
                    </span>
                  ),
                }
              : null,
            {
              id: "details",
              label: (
                <span
                  className="flex items-center"
                  style={{ minHeight: "20px", lineHeight: "20px" }}
                >
                  {t("Characteristics")}
                </span>
              ),
            },
            isAkanthasAccount && viewMode === "admin"
              ? {
                  id: "notifications",
                  label: (
                    <span
                      className="flex items-center"
                      style={{ minHeight: "20px", lineHeight: "20px" }}
                    >
                      {t("containerNotifications.tab")}
                    </span>
                  ),
                }
              : null,
          ].filter(Boolean)}
          activeTab={
            showActivity
              ? "activity"
              : showNotifications && isAkanthasAccount && viewMode === "admin"
                ? "notifications"
                : "details"
          }
          onTabChange={(tabId) => {
            setShowActivity(tabId === "activity");
            setShowDetails(tabId === "details");
            setShowNotifications(tabId === "notifications");
          }}
        />

        {/* Lock Toggle - visible only for Akanthas admins */}
        {isAkanthasAccount && viewMode === "admin" && container && (
          <FloatingLockToggle
            sectionName={showActivity ? t("Activity") : null}
            isLocked={
              showActivity
                ? !container.activatedActivityOption &&
                  !container.activatedFillingLevelOption &&
                  !container.activatedSortingErrorOption
                : false
            }
            onToggle={() => {
              if (showActivity) {
                handleToggle("activatedActivityOption");
                handleToggle("activatedFillingLevelOption");
                handleToggle("activatedSortingErrorOption");
              }
            }}
          />
        )}

        <div className="settings-content-wrapper">
          {showActivity && (
            <ContainerViewActivity data={container} updateData={updateData} />
          )}

          {showDetails && (
            <ContainerViewDetails
              data={container}
              countContentCategory={countContentCategory}
            />
          )}

          {showNotifications && isAkanthasAccount && viewMode === "admin" && (
            <ContainerViewNotifications containerId={container._id} />
          )}
        </div>
      </div>
    );
  }
};

export default ContainerDetailsView;
